const config = require('lc-config');
const defaults = require('../config/etcd-client-defaults');

config.util.setModuleDefaults('etcdClient', defaults);

module.exports = config;

